import React from 'react'

function MuteIcon() {
  return (
    <div className='flex items-center justify-center w-10 h-10 bg-black/[.60] rounded-full'>
      <svg
        role='button'
        xmlns='http://www.w3.org/2000/svg'
        aria-label='Mute'
        width='20'
        height='20'
        fill='none'
        viewBox='0 0 20 20'
      >
        <title>Mute</title>
        <g clipPath='url(#clip0_2387_72428)'>
          <path
            fill='#fff'
            d='M9.115 2.121a.442.442 0 01.747.323v15.111a.444.444 0 01-.747.323L4.55 13.556H1.443A.444.444 0 011 13.11V6.89c0-.246.198-.445.443-.445h3.108l4.564-4.323zm8.945 4.492l.94.943L16.563 10 19 12.444l-.94.943-2.437-2.445-2.437 2.445-.94-.943L14.682 10l-2.436-2.443.94-.943 2.437 2.444 2.437-2.444z'
          ></path>
        </g>
        <defs>
          <clipPath id='clip0_2387_72428'>
            <path fill='#fff' d='M0 0H20V20H0z'></path>
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

export default MuteIcon
